export default __webpack_public_path__ + "static/media/poppins-regular.6dad30c4.woff2";